import Splide from '@splidejs/splide';

let splide;
let onMoved = null;

/** Registers the handler run on splide's `moved` event. V1's PDP uses it to update the counter. */
export const setOnMoved = (handler) => {
  onMoved = handler;
};

const initSplide = (element) => {
  if (!element) return;

  if (splide) splide.destroy();
  const splideSettings = {
    type: 'loop',
    start: 0,
    focus: 'center',
    autoWidth: true,
    arrows: true,
    pagination: false,
    clones: 1,
    mediaQuery: 'min',
    breakpoints: {
      992: {
        destroy: true,
      },
    },
  };

  splide = new Splide(element, splideSettings).mount();
  if (onMoved) splide.on('moved', onMoved);
};

export const initMobileSlider = () => {
  let mobileSlider = document.querySelector('.pdp-splide');
  const cloudflareVideoRootElement = mobileSlider.querySelector(
    '.imageGrid.imageGrid__video .cloudflareVideoContainer'
  );

  if (cloudflareVideoRootElement && !splide) {
    CloudflareVideoInitializer.initWithRootElement(cloudflareVideoRootElement, () => {
      initSplide(mobileSlider);
    });
  } else {
    initSplide(mobileSlider);
  }
};
